import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer } from '@vextura/shell';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { FINAL_CTA } from '../content.js';

/**
 * Final CTA — one last shot. Dark band, single big headline, two CTAs
 * matching the hero. Anyone who scrolled this far is a serious lead; this
 * is where they convert or leave.
 */
export function FinalCta(): ReactNode {
  const navigate = useNavigate();
  return (
    <MarketingContainer variant="dark" paddingY="spacious">
      <div style={{ textAlign: 'center', maxWidth: 720, margin: '0 auto' }}>
        <SpaceBetween size="l">
          <h2
            style={{
              fontSize: 'clamp(32px, 5vw, 56px)',
              fontWeight: 800,
              letterSpacing: -1,
              lineHeight: 1.1,
              margin: 0,
              color: '#f8fafc',
            }}
          >
            {FINAL_CTA.headline}
          </h2>
          <p style={{ fontSize: 18, color: '#cbd5e1', margin: 0 }}>{FINAL_CTA.subhead}</p>
          <div
            style={{
              display: 'flex',
              gap: 12,
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginTop: 8,
            }}
          >
            <Button variant="primary" onClick={() => navigate(FINAL_CTA.primaryCta.href)}>
              {FINAL_CTA.primaryCta.label} →
            </Button>
            <Button variant="normal" onClick={() => navigate(FINAL_CTA.secondaryCta.href)}>
              {FINAL_CTA.secondaryCta.label}
            </Button>
          </div>
        </SpaceBetween>
      </div>
    </MarketingContainer>
  );
}
